import _ from "@lodash";
import * as Actions from "../Actions/WebexActions";

const initialState = {
   agendado: null,
   info: null,
   warning: null,
   error: null,
   integracao: null,
   participantes: null,
   open: false,
   chave: null,
   preload: false,
};

const WebexReducer = function (state = initialState, action) {
   switch (action.type) {
      case Actions.WEBEX_INFO: {
         return {
            ...state,
            info: action.payload,
            agendado: action.agendado,
            preload: false,
         };
      }
      case Actions.WEBEX_WARNING: {
         return {
            ...state,
            warning: action.payload,
            preload: false,
         };
      }
      case Actions.WEBEX_ERROR: {
         return {
            ...state,
            error: action.payload,
            preload: false,
         };
      }
      case Actions.WEBEX_GET_TOKEN: {
         return {
            ...state,
            integracao: !_.isNull(action.payload) && action.payload.length > 0 ? action.payload[0].setup : null,
            open: true
         };
      }
      case Actions.WEBEX_GET_PARTICIPANTS: {
         return {
            ...state,
            participantes: !_.isUndefined(action.payload) ? action.payload : null,
         };
      }
      case Actions.WEBEX_TOOGLE_MEETING: {
         return {
            ...state,
            open: !state.open
         }
      }
      case Actions.WEBEX_GET_CHAVE_INTEGRACAO: {
         return {
            ...state,
            chave: action.payload
         }
      }
      case Actions.WEBEX_PRELOAD: {
         return {
            ...state,
            preload: action.payload
         }
      }
      default: {
         return state;
      }
   }
};

export default WebexReducer;
